import i18n from "../i18n";

export function FormatIndianNumber(amount) {
  amount = parseFloat(amount);
  if (isNaN(amount)) {
    return "0";
  }

  const language = i18n.language === "fa" ? "en-IN" : (i18n.language || "en-IN");

  return Math.floor(amount).toLocaleString(language, {
    maximumFractionDigits: 0,
  });
}

export function ParseIndianNumber(formattedValue) {
  if (!formattedValue) return "";
  
  // Remove all non-digit characters (commas, spaces, etc.)
  const rawValue = formattedValue.toString().replace(/[^\d]/g, "");
  return rawValue;
}

// Enhanced change handler for the input
export function handleFormattedNumberChange(fieldName, formik, setFieldValue) {
  return (event) => {
    const inputValue = event.target.value;
    
    // Extract only digits from the input
    const rawValue = ParseIndianNumber(inputValue);
    
    // Update formik with the raw numeric value
    setFieldValue(fieldName, rawValue);
  };
}
